import { ComponentChildren, JSX } from 'preact';

type SliderProps = {
  value?: number;
  min: number;
  max: number;
  label: ComponentChildren;
  minLabel?: string;
  maxLabel?: string;
  step?: number;
  class?: string;
  onChange(value: number): void;
};

export function Slider({
  value,
  min,
  max,
  onChange,
  label,
  minLabel,
  maxLabel,
  step = 1,
  class: className = '',
}: SliderProps): JSX.Element {
  return (
    <div class={`flex flex-col gap-2 ${className}`}>
      <label class="block text-sm font-medium">{label}</label>
      <div class="relative">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          class="h-2 bg-gray-200 rounded-lg cursor-pointer accent-indigo-600 appearance-none"
          onChange={(e) => onChange(parseInt(e.currentTarget.value))}
        />
        <div class="flex gap-4 justify-between text-xs opacity-75">
          <span>{minLabel || min}</span>
          <span>{maxLabel || max}</span>
        </div>
      </div>
    </div>
  );
}
